import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, Observable } from 'rxjs';
import Keycloak, { KeycloakProfile } from 'keycloak-js';

@Injectable({
	providedIn: 'root',
})
export class KeycloakAuthService {
	constructor(private keycloak: KeycloakService) {}

	isLoggedIn(): Promise<boolean> {
		return this.keycloak.isLoggedIn();
	}

	public login(): Promise<void> {
		const url = new URL(window.location.href);
		const baseUrl = url.origin;

		const options: Keycloak.KeycloakLoginOptions = {
			prompt: 'login',
			redirectUri: window.location.href,
		};

		return this.keycloak.login(options);
	}

	async logout(): Promise<void> {
		if (await this.isLoggedIn()) {
			const baseUrl = window.location.origin;
			await this.keycloak.logout(baseUrl + '/');
		}
		this.clearToken();
	}

	public clearToken(): void {
		this.keycloak.clearToken();
	}

	public getUsername(): string {
		return this.keycloak.getUsername();
	}

	public getUserProfile(): Observable<KeycloakProfile> {
		return from(this.keycloak.loadUserProfile());
	}

	public getToken(): Observable<string> {
		return from(this.keycloak.getToken());
	}

	public isUserInRole(role: string): boolean {
		return this.keycloak.isUserInRole(role);
	}
}
